<template>
  <div class="page">
    <h2>Запись к врачу</h2>
    <div >
      <Form />
    </div>
  </div>
</template>

<script>
import Form from '../form/Form';
export default {
  components: {
    Form
  }
};
</script>

<style scoped>
h2 {
  color: #727272;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}
.vm-card {
  padding: 2rem;
  border-radius: 4px;
  background-color: #fff;
  background-color: #fff;
  box-shadow: 0 0 8px 5px rgba(0, 0, 0, 0.025);
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
</style>
